import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieConsentBanner from './CookieConsentBanner';
import { isBrandStoryLayoutPath, isLandingStylePath } from '../utils/landingRoutes';
import { stripLocalePrefix } from '../i18n/localeRouting';
import { scrollPageToTop } from '../utils/scrollToTop';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname, hash } = useLocation();
  const barePath = stripLocalePrefix(pathname);

  // 라우트가 바뀌어도 main 요소는 재사용되므로 이전 페이지의 scrollTop이 남는다.
  useLayoutEffect(() => {
    if (!hash) scrollPageToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barePath]);

  const isHomePage = barePath === '/';
  const isLandingStylePage = isLandingStylePath(pathname);
  const isBrandLayoutPage = isBrandStoryLayoutPath(pathname);
  // 즉시 리다이렉트되는 진입점은 푸터·쿠키 배너 생략
  const hideSiteChrome = barePath === '/start' || barePath === '/signup';

  return (
    <div className={`layout${isLandingStylePage ? ' layout--floating-landing-header' : ''}`}>
      <Header />
      <main
        className={`main main_container ${isHomePage ? 'home-page-container' : ''} ${
          isBrandLayoutPage ? 'brand-story-container' : ''
        }`}
      >
        {children}
        {/* 기존과 같이 main 스크롤 영역 맨 아래에 배치 */}
        {hideSiteChrome ? null : <Footer />}
      </main>
      {hideSiteChrome ? null : <CookieConsentBanner />}
    </div>
  );
};

export default Layout;
